import { AnalyticsBrowser } from '@segment/analytics-next'
import { IS_DEV, env } from '@/config'
import { uuidWeak, getCookie } from '@/util'

class AnalyticsDummyPlugin {
    constructor() {
        return new Proxy(this, {
            get(target, prop) {
                if (prop in target) return target[prop]
                return (...args) => console.log('Analytics DEBUG: %s', prop, ...args)
            }
        })
    }
}

class AnalyticsPlugin {
    constructor(store, router, config) {
        this.store = store
        this.router = router
        this.analytics = AnalyticsBrowser.load(config)
        this.currentUserId = null
    }

    get user() {
        return this.store.getters.userResource?.attributes || null
    }

    get baseUserData() {
        const user = this.user

        if (!user) {
            return {}
        }

        return {
            email: user.email || null,
            first_name: user.first_name || null,
            last_name: user.last_name || null,
            phone: user.phone || null,
            birthday: user.birthday || null,
            zip: user.zip_code || null,
            external_id: String(this.store.getters.userId),
            fbc: getCookie('_fbc'),
            fbp: getCookie('_fbp')
        }
    }

    identify(props = {}) {
        const userId = this.store.getters.userId
        
        if (!userId) {
            return false
        }

        this.currentUserId = userId
        this.analytics.identify(String(userId), Object.assign({}, this.baseUserData, { location_group_id: this.user?.location_group_id || env.API_LOCATION_GROUP_ID || 'SHIFT' }, props))
        return true
    }

    track(eventName, props = {}) {
        const event_id = uuidWeak()
        const location_group_id = this.user?.location_group_id || env.API_LOCATION_GROUP_ID || 'SHIFT'
        const defaults = { event_id, location_group_id, fbc: getCookie('_fbc'), fbp: getCookie('_fbp') }
        const eventPayload = Object.assign(defaults, props)
        this.analytics.track(eventName, eventPayload)
        return event_id
    }

    alias(aliasId, originalId) {
        this.analytics.alias(aliasId, originalId)
    }
}

export default {
    install(app, options) {
        const { store, router, writeKey } = options

        app.prototype.$analytics = IS_DEV || !writeKey ? new AnalyticsDummyPlugin() : new AnalyticsPlugin(store, router, { writeKey })

        router.afterEach((to) => {
            const analytics = app.prototype.$analytics
            const userId = store.getters.userId

            if (userId && analytics.currentUserId !== userId) {
                analytics.identify()
            }

            analytics.track(to.name || 'PageView', {
                path: to.fullPath,
                params: to.params,
                query: to.query
            })
        })
    }
}